import { render, staticRenderFns } from "./InsuranceCompanies.vue?vue&type=template&id=21bfa431&"
import script from "./InsuranceCompanies.vue?vue&type=script&lang=js&"
export * from "./InsuranceCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports